export function createFormData(bodyContent: Record<string, string>) {
    const body = new FormData();
    for (const [key, value] of Object.entries(bodyContent)) {
        body.append(key, value);
    }
    return body;
}
